// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"600":"538c00de","746":"4880391c"}[chunkId] + ".chunk.js";
};